/* eslint-disable no-unused-expressions */
import {
  ZENDESK_CHECK_INTERVAL,
  ZENDESK_CHECK_LIMIT,
  CANCEL_CHAT_ROUTES,
  SUPPORT_CHAT_BLACKLIST,
} from 'constants/chat';

export const isSupportChatRoute = route => {
  const cleanedRoute = route.replace(/^\//, '');
  return !SUPPORT_CHAT_BLACKLIST.some(blacklistRoute => cleanedRoute.startsWith(blacklistRoute));
};

export const isCancelChatRoute = route => {
  const cleanedRoute = route.replace(/^\//, '');
  return CANCEL_CHAT_ROUTES.some(cancelRoute => cleanedRoute === cancelRoute);
};

const MAX_NUM_CHECKS = ZENDESK_CHECK_LIMIT / ZENDESK_CHECK_INTERVAL;

export const whenZDChatIsLoaded = (successCallback, failureCallback) => {
  let numChecks = 0;

  const timer = setInterval(() => {
    const zendeskChat = window?.zE;
    if (zendeskChat) {
      successCallback();
      clearInterval(timer);
    }

    numChecks += 1;
    if (numChecks === MAX_NUM_CHECKS) {
      failureCallback?.();
      clearInterval(timer);
    }
  }, ZENDESK_CHECK_INTERVAL);
  return timer;
};
